import { Coach } from '@/mocks/roster';

interface CoachCardProps {
  coach: Coach;
  featured?: boolean;
}

export default function CoachCard({ coach, featured = false }: CoachCardProps) {
  if (featured) {
    return (
      <div className="relative rounded-lg overflow-hidden bg-gradient-to-br from-[#4a1a6b] to-[#2a0a3d] flex flex-col md:flex-row">
        <div className="relative w-full md:w-64 h-64 md:h-auto flex-shrink-0 overflow-hidden">
          <img
            src={coach.image}
            alt={coach.name}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#4a1a6b]/60 hidden md:block"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#4a1a6b]/80 to-transparent md:hidden"></div>
        </div>
        <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
          <span className="inline-block px-3 py-1 rounded-full bg-[#ffd700] text-[#4a1a6b] text-xs font-black tracking-widest uppercase mb-3 w-fit" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Head Coach
          </span>
          <h3 className="text-2xl md:text-3xl font-black text-white mb-1" style={{ fontFamily: "'Oswald', sans-serif" }}>
            {coach.name}
          </h3>
          <p className="text-[#ffd700] text-sm tracking-widest uppercase mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
            {coach.experience} · {coach.college}
          </p>
          <p className="text-white/70 text-sm leading-relaxed max-w-lg">{coach.bio}</p>
          <div className="flex items-center gap-6 mt-6 pt-6 border-t border-white/10">
            <div>
              <p className="text-white/40 text-[10px] uppercase tracking-wider mb-0.5" style={{ fontFamily: "'Oswald', sans-serif" }}>Experience</p>
              <p className="text-white text-sm font-bold" style={{ fontFamily: "'Oswald', sans-serif" }}>{coach.experience}</p>
            </div>
            <div>
              <p className="text-white/40 text-[10px] uppercase tracking-wider mb-0.5" style={{ fontFamily: "'Oswald', sans-serif" }}>College</p>
              <p className="text-white text-sm font-bold" style={{ fontFamily: "'Oswald', sans-serif" }}>{coach.college}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg overflow-hidden border border-gray-100 group hover:border-[#4a1a6b]/20 transition-all duration-300">
      <div className="relative h-52 overflow-hidden bg-gradient-to-b from-[#4a1a6b]/10 to-[#4a1a6b]/5">
        <img
          src={coach.image}
          alt={coach.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
      </div>
      <div className="px-4 pb-5 pt-2">
        <h3 className="text-base font-black text-[#2a0a3d] leading-tight" style={{ fontFamily: "'Oswald', sans-serif" }}>
          {coach.name}
        </h3>
        <p className="text-[#4a1a6b] text-xs font-semibold tracking-wider uppercase mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
          {coach.title}
        </p>
        <p className="text-gray-500 text-xs leading-relaxed mb-3 line-clamp-3">{coach.bio}</p>
        <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
          <div className="flex-1">
            <p className="text-[10px] text-gray-400 uppercase tracking-wider" style={{ fontFamily: "'Oswald', sans-serif" }}>Experience</p>
            <p className="text-xs font-bold text-[#2a0a3d]" style={{ fontFamily: "'Oswald', sans-serif" }}>{coach.experience}</p>
          </div>
          <div className="flex-1">
            <p className="text-[10px] text-gray-400 uppercase tracking-wider" style={{ fontFamily: "'Oswald', sans-serif" }}>College</p>
            <p className="text-xs font-bold text-[#2a0a3d]" style={{ fontFamily: "'Oswald', sans-serif" }}>{coach.college}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
